import { render } from "./agentDetailDialog.vue?vue&type=template&id=10a06edc"
import script from "./agentDetailDialog.vue?vue&type=script&lang=js"
export * from "./agentDetailDialog.vue?vue&type=script&lang=js"

import "./agentDetailDialog.vue?vue&type=style&index=0&id=10a06edc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__